import { cdlDef } from '../../cdl'

export default cdlDef({ id: 'CDLMORNINGSTAR', label: 'Morning Star', lookback: 12, penetration: 0.3 })
